import React from 'react';
import '../../styles/components/profile_page/BioSection.css';

const BioSection = ({ bio, isOwner, onAddClick }) => {
  if (!bio) {
    return isOwner ? (
      <p className="bio-empty">
          Add a bio…
      </p>
    ) : null;
  }

  return (
    <div className="bio-section">
      <p className="bio-text">{bio}</p>
    </div>
  );
};

export default BioSection;